var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasRole(_vm.AdminUserPermissions.TAX_SETTINGS))?_c('UpdateTax'):_vm._e(),(_vm.hasRole(_vm.AdminUserPermissions.PAYMENT_VIEW))?_c('AccountTable'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }